import { createStore } from 'vuex';
import partnerModule from './modules/partners';
import realEstateModule from './modules/real-estate';
import actions from './actions.js';
import getters from './getters.js';
import mutations from './mutations.js';
import { ORGANIZATION_UUID } from '../shared/config.js';

const store = createStore({
    modules: {
        partners: partnerModule,
        realEstate: realEstateModule
    },
    state() {
        return {
            partnerTypes: [],
            user: {
                organizationUuid: ORGANIZATION_UUID
            },
            loadingBaseData: false,
            editingUser: false
        };
    },
    actions,
    getters,
    mutations
});

export default store;